/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_JobInputs */

const en_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Job`)
};

const de_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Stelle`)
};

const fr_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvel emploi`)
};

const es_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo empleo`)
};

const it_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo lavoro`)
};

const nl_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe baan`)
};

const pl_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowa oferta`)
};

const fi_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi työpaikka`)
};

const da_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyt job`)
};

const sv_jobs_new_job = /** @type {(inputs: Jobs_New_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt jobb`)
};

/**
* | output |
* | --- |
* | "New Job" |
*
* @param {Jobs_New_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_new_job = /** @type {((inputs?: Jobs_New_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_new_job(inputs)
	if (locale === "fr") return fr_jobs_new_job(inputs)
	if (locale === "es") return es_jobs_new_job(inputs)
	if (locale === "it") return it_jobs_new_job(inputs)
	if (locale === "nl") return nl_jobs_new_job(inputs)
	if (locale === "pl") return pl_jobs_new_job(inputs)
	if (locale === "fi") return fi_jobs_new_job(inputs)
	if (locale === "da") return da_jobs_new_job(inputs)
	if (locale === "sv") return sv_jobs_new_job(inputs)
	return en_jobs_new_job(inputs)
});